<template lang="pug">
    .entity
        form.form
            .entity__title Персональные данные
            .entity__title-mini Фамилия, Имя, Отчество
            .form__flex
                .form__group.form__group--mini
                    label.form__label Фамилия
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Имя
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Отчество
                    input(type="text").form__input

            .entity__title-mini Паспортные данные
            .form__flex
                .form__group.form__group--mini
                    label.form__label Серия
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Номер
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Дата выдачи документа
                    date-picker(v-model="documentDate" format="DD.MM.YYYY").form__input
            .form__group.form__group--big
                label.form__label Наименование органа, выдавшего документ
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Код подразделения
                input(type="text").form__input
            .form__group.form__group--mini
                label.form__label Дата рождения
                date-picker(v-model="birthday" format="DD.MM.YYYY").form__input
            .form__group.form__group--big
                label.form__label Место рождения
                input(type="text").form__input


            .form__group.form__group--file
                .form__label Скан-копия первой страницы паспорта (pdf, jpg, jpeg, png)
                .form__flex
                    label(for="scan1").form__label-file
                        | Выберите файл
                        svgicon(name="file")
                    input(type="file" @change="previewFiles")#scan1.form__input-file
                    input(type="text" :value="this.scan1").form__input
            .form__group.form__group--file
                .form__label Скан-копия страницы паспорта, содержащей данные о прописке (pdf, jpg, jpeg, png)
                .form__flex
                    label(for="scan2").form__label-file
                        | Выберите файл
                        svgicon(name="file")
                    input(type="file" @change="previewFiles")#scan2.form__input-file
                    input(type="text" :value="this.scan2").form__input
            .form__group.form__group--big
                label.form__label Адрес регистрации
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Почтовый адрес
                input(type="text").form__input
            .form__flex
                .form__group.form__group--mini
                    label.form__label ИНН
                    input(type="text").form__input
                .form__group.form__group--mini
                    label.form__label Номер СНИЛС
                    input(type="text").form__input
            .form__group.form__group--file
                .form__label Скан-копия СНИЛС (pdf, jpg, jpeg, png)
                .form__flex
                    label(for="scan3").form__label-file
                        | Выберите файл
                        svgicon(name="file")
                    input(type="file" @change="previewFiles")#scan3.form__input-file
                    input(type="text" :value="this.scan3").form__input


            .entity__title Банковские реквизиты
            .entity__title-mini Введите БИК, и мы автоматически заполним поля к/с и наименование банка,
                br
                | чтобы ускорить процесс регистрации.
            .form__group.form__group--big
                label.form__label БИК банка
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Корреспондентский счет
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Наименование банка
                input(type="text").form__input
            .form__group.form__group--big
                label.form__label Расчётный счёт
                input(type="text").form__input
            .form__group
                p-check(name="pers" class="input-round p-svg p-round p-pulse wrap-text\n" color="primary")
                    svgicon(name="check" class="svg")
                    |Даю согласие на обработку
                    a(href="#") персональных данных
            button.btn.btn--big Сохранить
</template>

<script>
  export default {
    name: 'indent',
    data() {
      return {
        birthday: null,
        documentDate: null,
        scan1: null,
        scan2: null,
        scan3: null,
      }
    },
    methods: {
      previewFiles(event) {
        const id = event.target.id;
        this[id]  = event.target.files[0].name
      }
    }
  }
</script>

<style lang="scss">

</style>
